export type TemplateAssignationStatus =
  | "no-tags"
  | "default-tags"
  | "user-assigned-tags";

export enum MailHost {
  OFFICE = 0,
  GMAIL = 1,
}

export enum StepperStateKey {
  MAILING_PERMISSIONS = 0,
  PROVISIONING_PERMISSIONS = 1,
  PROVISION_ONE_USER = 2,
  COMPANY_SCAN = 3,
  MAP_GROUPS_DEPARTMENTS = 4,
}

type CompanyScanStatus = {
  has_key_people: boolean;
  has_company_logo: boolean;
  has_email_signature: boolean;
  has_key_customers: boolean;
};

export type ServiceAccountStatus = {
  is_set_up: boolean;
  unique_id: string | null;
  email: string | null;
};

export type GeneralSettingsSetupChecklistStatus = {
  mail_host: MailHost;
  has_mail_permissions: boolean;
  has_provisioning_permissions: boolean;
  has_at_least_one_non_admin_user: boolean;
  company_scan: CompanyScanStatus;
  has_mapped_groups_to_departments: boolean;
  service_account_status: ServiceAccountStatus;
};
